import React, { Component } from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import PropTypes from 'prop-types';
import { ai } from './TelemetryService';
import { history } from '../redux/store';

class TelemetryProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialized: false,
    };
  }

  componentDidMount() {
    // const { history } = this.props;
    const { initialized } = this.state;
    const { instrumentationKey, after } = this.props;
    if (!initialized && Boolean(instrumentationKey) && Boolean(history)) {
      ai.initialize(instrumentationKey, history);
      this.setState({ initialized: true });
    }

    after();
  }

  render() {
    const { children } = this.props;
    return (
      <>
        {children}
      </>
    );
  }
}
TelemetryProvider.propTypes = {
  after: PropTypes.func.isRequired,
  instrumentationKey: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default withAITracking(ai.reactPlugin, TelemetryProvider);
